import React from "react";

import { Btn, Icon } from "../catalogProductStudio/edit/StudioUi";
import { fill } from "./metaAdsModel";

/**
 * The single technical detail of this feature, kept out of the way: whoever
 * manages the ads creates the product set in Meta once, filtered on this
 * label, and from then on the CMS controls what is in it.
 */
const MetaSetupPanel = ({ labelKey, tt, onCopied }) => {
  const copyLabel = async () => {
    try {
      await navigator.clipboard.writeText(labelKey);
      onCopied?.();
    } catch (_error) {
      // Clipboard can be blocked; the label is selectable on screen anyway.
    }
  };

  return (
    <details className="mka-setup">
      <summary className="mka-setup__summary">
        <Icon name="meta" size={18} />
        <span className="mka-setup__summary-text">
          <strong>{tt("setupTitle")}</strong>
          <span>{tt("setupSummary")}</span>
        </span>
        <Icon name="chevronDown" size={16} className="mka-setup__chevron" />
      </summary>
      <div className="mka-setup__body">
        <p>{tt("setupIntro")}</p>
        <ol className="mka-setup__steps">
          <li>{tt("setupStep1")}</li>
          <li>{tt("setupStep2")}</li>
          <li>
            {tt("setupStep3")}
            <div className="mka-setup__rule">
              <span className="mka-setup__rule-part">{tt("setupRuleField")}</span>
              <span className="mka-setup__rule-part mka-muted">{tt("setupRuleOperator")}</span>
              <code className="mka-setup__label">{labelKey}</code>
              <Btn variant="ghost" size="sm" icon="copy" onClick={copyLabel}>
                {tt("copy")}
              </Btn>
            </div>
          </li>
        </ol>
        <p className="mka-setup__warning">{fill(tt("setupOnlyThisRule"), { label: "ads_primary" })}</p>
        <p className="mka-muted mka-small">{tt("setupRenameNote")}</p>
      </div>
    </details>
  );
};

export default MetaSetupPanel;
